function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import _merge from 'deepmerge';

/**
 * @hoc WithSx
 */
import { jsx as ___EmotionJSX } from "@emotion/react";
const WithSx = (Component, staticSx) => /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    sx = {},
    ...otherProps
  } = props;
  const finalSx = typeof sx === 'function' ? sx() : _merge(staticSx, sx);
  return ___EmotionJSX(Component, _extends({
    ref: ref,
    sx: finalSx
  }, otherProps));
});
export default WithSx;